var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgNotEquals = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.941409 1.04149C0.863304 0.963384 0.736671 0.963384 0.658566 1.04149L0.092881 1.60717C0.0147761 1.68528 0.014776 1.81191 0.0928809 1.89002L3.00291 4.80004H0.2C0.0895431 4.80004 0 4.88959 0 5.00004V5.80004C0 5.9105 0.0895429 6.00004 0.2 6.00004H4.20291L6.20292 8.00006H0.2C0.0895431 8.00006 0 8.0896 0 8.20006V9.00006C0 9.11051 0.0895429 9.20006 0.2 9.20006H7.40292L11.1237 12.9209C11.2019 12.999 11.3285 12.999 11.4066 12.9209L11.9723 12.3552C12.0504 12.2771 12.0504 12.1505 11.9723 12.0724L0.941409 1.04149ZM8.79999 8.00006L9.99999 9.20006H11.8C11.9105 9.20006 12 9.11051 12 9.00006V8.20006C12 8.0896 11.9105 8.00006 11.8 8.00006H8.79999ZM5.59998 4.80004L6.79998 6.00004H11.8C11.9105 6.00004 12 5.9105 12 5.80004V5.00004C12 4.88959 11.9105 4.80004 11.8 4.80004H5.59998Z",
    fill: "#2C4652",
    fillOpacity: 0.5
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgNotEquals, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/not-equals.b54aafd5.svg";
export { ForwardRef as ReactComponent };